import React, { Component } from "react";
import "@/App.css";
import LenisProvider from "@/components/LenisProvider";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Portfolio from "@/components/Portfolio";
import Process from "@/components/Process";
import About from "@/components/About";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import { Toaster } from "sonner";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error) {
    console.error(error);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-cream p-10 text-center">
          <p className="font-serif text-3xl text-olive">
            Algo salió mal. Por favor recarga la página.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  return (
    <LenisProvider>
      <ErrorBoundary>
        <div className="min-h-screen bg-cream font-sans text-olive">
          <Header />
          <main>
            <Hero />
            <Marquee />
            <Services />
            <Portfolio />
            <Process />
            <About />
            <Testimonials />
            <Contact />
          </main>
          <Footer />
          <ChatWidget />
          <Toaster position="bottom-right" />
        </div>
      </ErrorBoundary>
    </LenisProvider>
  );
}

export default App;
